export default "__VITE_ASSET__1f099a97__"